import iwanthue from 'iwanthue';
import { useMemo } from 'react';

import { ColorProviderContext } from './ColorProviderContext';

import { useMeQuery } from '@/features/Shared/api/me';

interface OrganizationColorProviderProps {
	children: React.ReactNode;
}

export const OrganizationsColorProvider = ({ children }: OrganizationColorProviderProps) => {
	const { data } = useMeQuery();

	const colors = useMemo(() => {
		if (!data) {
			return {};
		}

		const organizations = data?.organizations || [];
		if (!organizations.length) {
			return {};
		}

		const palette = iwanthue(organizations.length, {
			ultraPrecision: true,
			quality: 100,
			colorSpace: 'default',
			clustering: 'force-vector',
			distance: 'euclidean',
		});

		const colorsMap: Record<string, string> = {};
		organizations.forEach((org, index) => {
			colorsMap[org.id] = palette[index];
		});

		return colorsMap;
	}, [data]);

	return (
		<ColorProviderContext.Provider value={{ colors }}>{children}</ColorProviderContext.Provider>
	);
};
